import dayjs from 'dayjs';

const month = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

export function getCurrentMonth(): string {
  return month[dayjs().month()];
}
